
import {Component, Vue,} from "vue-property-decorator";
import ConfirmDialog from "../ConfirmDialog.vue";
import {currentUserModule, studyDefinitionModule, studyModule, studyPatientsModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import {formatDateTime} from "@/auxillary/date-format";
import StudyPatientShortDto = MdbsCore.StudyPatientShortDto;
import Rights = MdbsCore.Rights;

@Component({
  components: {
    ConfirmDialog
  },
  filters: {
    formatDateTime
  }
})
export default class PatientTable extends Vue {
  private _loading: boolean = false;

  headers: any = [
    {
      text: 'Patienten ID',
      align: 'left',
      value: 'displayName'
    },
    {
      text: 'Registrierungsdatum',
      align: 'left',
      value: 'registrationDate',
      filterable: false
    },
    {
      text: 'Aktionen',
      sortable: false,
      width: "120px",
      value: 'actions',
      filterable: false
    },
  ];
  search: string = "";

  async mounted() {
    if (currentUserModule.hasRight(Rights.StudyPatientGetAllCmd)) {
      await studyPatientsModule.loadAll();
      return;
    }
    await studyPatientsModule.loadMy();
  }

  get patients() {
    return studyPatientsModule.studyPatients;
  }

  get loading() {
    return this._loading || studyPatientsModule.isLoading;
  }

  get studyName() {
    return studyModule.study.displayName;
  }

  get canEditPatient() {
    return currentUserModule.hasRight(Rights.PatientUpdateCmd);
  }

  get canCreatePatient() {
    return currentUserModule.hasRight(Rights.PatientCreateCmd) && !currentUserModule.isNtdUser && this.recruitmentOngoing;
  }

  get recruitmentOngoing() {
    let endDateString = studyDefinitionModule.studyDefinition.patient?.definition?.recruitmentEndDate;
    if (endDateString == undefined || endDateString == "")
      return true;

    const endDate = new Date(endDateString);
    const dateNow = new Date(Date.now());
    return endDate > dateNow;
  }

  async createNewPatient() {
    await this.$router.push({
      name: 'patientnew',
    })
  }

  async editPatient(patient: StudyPatientShortDto) {
    await this.$router.push({
      name: "patientedit",
      params: {patientId: patient.id}
    })
  }

  async openPatient(patient: StudyPatientShortDto) {
    await this.$router.push({
      name: "patient",
      params: {patientId: patient.id}
    }).catch();
  }

}
